import React, { Component } from "react";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faShare,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";

export default class TBLCupons extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.columns = [
      {
        Header: "Código",
        accessor: "codigo",
        className: "center",
      },
      {
        Header: "Ativo",
        accessor: "ativo",
        className: "center",
        Cell: (props) => <span>{props.value ? "Sim" : "Não"}</span>,
      },
      {
        Header: "Ativaçôes",
        accessor: "num_ativacoes_geral",
        className: "center",
      },
      {
        Header: "Consumo Total",
        accessor: "consumo_geral",
        className: "center",
        Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
      },
      {
        Header: "Recurso Total",
        accessor: "recurso",
        className: "center",
        Cell: (props) => <span>R$ {parseFloat(props.value).toFixed(2)}</span>,
      },
      {
        Header: "Disponivel Total",
        accessor: "disponivel_geral",
        className: "center",
        Cell: (row) => (
          <span>
            R${" "}
            {parseFloat(
              row.row._original.recurso - row.row._original.consumo_geral
            ).toFixed(2)}
          </span>
        ),
      },
      {
        Header: "Ações",
        Cell: (row) => {
          if (!this.props.isDespacho) {
            return (
              <div>
                <Button
                  size="sm"
                  style={{ marginRight: 4 }}
                  onClick={() =>
                    this.gerenciarAcoes("editar", row.row._original)
                  }
                >
                  <FontAwesomeIcon icon={faEdit}></FontAwesomeIcon>
                </Button>
                <Button
                  size="sm"
                  style={{ marginRight: 4 }}
                  variant="danger"
                  onClick={() =>
                    this.gerenciarAcoes("deletar", row.row._original)
                  }
                >
                  <FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                </Button>
                <Button
                  size="sm"
                  onClick={() =>
                    this.gerenciarAcoes("ver_detalhes", row.row._original)
                  }
                >
                  <FontAwesomeIcon icon={faListUl}></FontAwesomeIcon>
                </Button>
              </div>
            );
          } else {
            return (
              <Button
                size="sm"
                onClick={() =>
                  this.gerenciarAcoes("separador_despachado", row.row._original)
                }
              >
                <FontAwesomeIcon icon={faShare}></FontAwesomeIcon>Despachar
              </Button>
            );
          }
        },
        className: "center",
      },
    ];
  }

  setData = (data) => {
    if (this.props.context === "detalhes_cupom") {
      this.columns[0] = {
        Header: "Estabelecimento",
        accessor: "estabelecimento.nome_fantasia",
        className: "center",
      };
      data = [this.props.cupom];
    }
    if (this.props.context === "estabelecimento") {
      this.columns.splice(
        2,
        0,
        {
          Header: "Consumo",
          accessor: "consumo",
          className: "center",
        },
        {
          Header: "Disponível",
          accessor: "disponivel",
          className: "center",
        }
      );
    }
  };

  gerenciarAcoes = (tipo, dados) => {
    if (tipo === "editar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "deletar") {
      this.props.dataCallback(tipo, dados);
    } else if (tipo === "ver_detalhes") {
      this.props.dataCallback(tipo, dados);
    } else {
      return;
    }
  };

  render() {
    this.setData(this.props.data);
    return (
      <ReactTable
        data={this.props.data}
        className="-striped -highlight"
        columns={this.columns}
        resizable
        style={{ maxHeight: 572 }}
        showPagination={this.props.showPagination}
        defaultPageSize={this.props.numRows}
        previousText="Anterior"
        nextText="Próximo"
        loadingText="Carregando..."
        noDataText="Nenhum dado encontrado!"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
      />
    );
  }
}

TBLCupons.propTypes = {
  data: PropTypes.array,
  showPagination: PropTypes.bool,
  numRows: PropTypes.number,
  dataCallback: PropTypes.func,
  isDespacho: PropTypes.bool,
};
